import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year2/Spring/LengthAndHeight/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'LengthAndHeight',
  field: 'Measurement',
  weeks: [8, 9],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/LengthAndHeight/1MeasureInCentimetres" */ './1MeasureInCentimetres'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/LengthAndHeight/2MeasureInMetres" */ './2MeasureInMetres'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/LengthAndHeight/3CompareLengthsAndHeights" */ './3CompareLengthsAndHeights'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/LengthAndHeight/4OrderLengthsAndHeights" */ './4OrderLengthsAndHeights'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/LengthAndHeight/5FourOperationsWithLengthsAndHeights" */ './5FourOperationsWithLengthsAndHeights'
        )
    })
  ]
});
export default Block;
